import { render, staticRenderFns } from "./allocationFBA.vue?vue&type=template&id=71f4cc6d&scoped=true&"
import script from "./allocationFBA.vue?vue&type=script&lang=js&"
export * from "./allocationFBA.vue?vue&type=script&lang=js&"
import style0 from "./allocationFBA.vue?vue&type=style&index=0&id=71f4cc6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4cc6d",
  null
  
)

export default component.exports